import { useSelector } from 'react-redux';

const useGetCarQuoteList = () => {
    return useSelector((state) => state.carQuoteList.carQuoteList);
};

export default useGetCarQuoteList;